class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    //load desktop price range
    FacetFiltersForm.loadPriceSlider();
    FacetFiltersForm.loadMobilePriceSlider();

  }

  static loadPriceSlider() {
    setTimeout( () => {
      window.initialisePriceSlider();
    },100)
  }

  static loadMobilePriceSlider() {
    setTimeout( () => {
      try {
        window.initialiseMobilePriceSlider();
      } catch( error ) {

      }
    },100)
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }
      
    sections.forEach((section) => {
      
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    console.log(url)
    
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        FacetFiltersForm.loadPriceSlider();
        FacetFiltersForm.loadMobilePriceSlider();
        //Trigger discount event if any exist.
        if(window.discountsResponse) {
          window.dispatchEvent(new CustomEvent('discount_loaded', {
            detail: window.discountsResponse,
          }));
        }
        
        let allProduct = [...document.querySelectorAll('.collection-product-item')];
          for(let i = 0; i < allProduct.length; i++) {
            if(window.discountsResponse.status) {
              const product_collections = allProduct[i].dataset.productCollection;
              const productId = allProduct[i].dataset.productId;
              const discounts = window.discountsResponse?.request?.data?.automaticDiscountNodes?.edges.filter(item => !_.isEmpty(item.node.automaticDiscount));
              if(!discounts) return;//No need to proceed)
              //Check if the product can be discounted.
              let percentage = null;
              const collectionsAvailable =  product_collections
              discounts.forEach( discount => {
                const inCollection = discount?.node?.automaticDiscount?.customerGets?.items?.collections?.edges.map( edge => edge?.node?.handle )
                if(inCollection && inCollection.some( item => collectionsAvailable.includes(item))) {
                  if(discount?.node?.automaticDiscount?.customerGets?.value?.percentage) {
                    percentage = discount?.node?.automaticDiscount?.customerGets?.value?.percentage;
                  }
                }
              });
              if(percentage) {
                const _priceTemplate = document.querySelectorAll(`.price__template-product-${productId}`);
                if(_priceTemplate.length) {
                  _priceTemplate.forEach( priceTemplate => {              
                    if(!priceTemplate) return;
                    const priceSelector = priceTemplate.querySelector('.price__regular .price-item--regular');
                    if(!priceSelector) return;
                    priceSelector.classList.add('strike-through')
          
                    const priceValue = priceSelector.getAttribute('data-price');
                    priceTemplate.querySelector('.price__regular_discounted').innerText = Shopify.formatMoney(priceValue - (priceValue * percentage));
                    priceTemplate.querySelector('.price__regular_discounted_percentage').innerText = `${percentage * 100}% off`;
                  })
                }
        
              }
            }
          }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    //Refrain by reloading the page 
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      if(element.id && element.dataset.index) {
        document.querySelector(`#${element.id}.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    // if (countsToRender) {
    //   const closestJSFilterID = event.target.closest('.js-filter').id;
      
    //   if (closestJSFilterID) {
    //     FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    //     FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

    //     const newFacetDetailsElement = document.getElementById(closestJSFilterID);
    //     const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
    //       ? `.mobile-facets__close-button`
    //       : `.facets__summary`;
    //     const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
    //     if (newElementToActivate) newElementToActivate.focus();
    //   }
    // }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }
  getUrlParams(url) {
    
    const pairs = url.split('&');
    const result = {};
  
    pairs.forEach(pair => {
      const [key, value] = pair.split('=');
      if (result[key]) {
        if (Array.isArray(result[key])) {
          result[key].push(value || '');
        } else {
          result[key] = [result[key], value || ''];
        }
      } else {
        result[key] = value || '';
      }
    });
  
    return result;
  }
  updateUrlParams(params) {
    return Object.keys(params)
    .map(key => {
      if (Array.isArray(params[key])) {
        return params[key].map(value => `${key}=${value}`).join('&');
      }
      return `${key}=${params[key]}`;
    })
    .join('&');
  }
  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
      
      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            const url = this.createSearchParams(form)
            const params = this.getUrlParams(url);
          if (parseFloat(params['filter.v.price.gte']) > 0) {
            const discountedPriceGte = parseInt(params['filter.v.price.gte']) * 10 / 7;
            params['filter.v.price.gte'] = parseInt(discountedPriceGte);
            
          }
          
          if (parseFloat(params['filter.v.price.lte']) > 0) {
            const discountedPriceLte = parseInt(params['filter.v.price.lte']) * 10 / 7;
            params['filter.v.price.lte'] = parseInt(discountedPriceLte);
            
          }
          
          const updatedUrl = this.updateUrlParams(params);
          forms.push(updatedUrl);
            // forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          
          const url = this.createSearchParams(form)
          const params = this.getUrlParams(url);
          if (parseInt(params['filter.v.price.gte']) > 0) {
            const discountedPriceGte = parseInt(params['filter.v.price.gte']) * 10 / 7;
            params['filter.v.price.gte'] = parseInt(discountedPriceGte);
            
          }
          
          if (parseInt(params['filter.v.price.lte']) > 0) {
            const discountedPriceLte = parseInt(params['filter.v.price.lte']) * 10 / 7;
            params['filter.v.price.lte'] = parseInt(discountedPriceLte);
            
          }
          
          const updatedUrl = this.updateUrlParams(params);
          forms.push(updatedUrl);
        }
      });
      console.log("Asdasdasdasd",forms)
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    
    // const discountPercentage = 30;
    // const discountAmount = maxInput.value * (discountPercentage / 100);
    // const discountedPrice = maxInput.value - discountAmount;
    // if (maxInput.value) minInput.setAttribute('max', discountedPrice);
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);



class RockherPriceDiscount extends HTMLElement {
  constructor() {
    super();

    try {

      window.addEventListener('discount_loaded', event => {
        
        const discounts = window?.discountsResponse?.request?.data?.automaticDiscountNodes?.edges.filter(item => !_.isEmpty(item.node.automaticDiscount));
        if(!discounts) return;//No need to proceed)
        const product_collections = JSON.parse(this.getAttribute('collections'))
        const id = this.getAttribute('id')
    
        //Check if the product can be discounted.
        let percentage = null;
        const collectionsAvailable = product_collections
        discounts.forEach( discount => {
          const inCollection = discount?.node?.automaticDiscount?.customerGets?.items?.collections?.edges.map( edge => edge?.node?.handle )
          if(inCollection && inCollection.some( item => collectionsAvailable.includes(item))) {
            if(discount?.node?.automaticDiscount?.customerGets?.value?.percentage) {
              percentage = discount?.node?.automaticDiscount?.customerGets?.value?.percentage;
            }
          }
        });
    
        if(percentage) {
          const priceTemplate = document.querySelector(`.price__template-product-${id}`);
          if(!priceTemplate) return;
          const priceSelector = priceTemplate.querySelector('.price__regular .price-item--regular');
          if(!priceSelector) return;
          priceSelector.classList.add('strike-through')
    
          const priceValue = priceSelector.getAttribute('data-price');
          priceTemplate.querySelector('.price__regular_discounted').innerText = Shopify.formatMoney(priceValue - (priceValue * percentage));
          priceTemplate.querySelector('.price__regular_discounted_percentage').innerText = `${percentage * 100}% off`;
    
        }

      })


    } catch( error ) {
      console.log(error)
    }

  }
}

customElements.define('rockher-price-discount', RockherPriceDiscount);